import { useCallback, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { STALE_TIME, CACHE_TIME } from '~/common/constants/react-query.const';

import { GamificationQueryKeys } from '../../../query';
import { getLoyaltyRewardHistory } from '../../../services/gamification.service.api';

function generateAvailablePeriods(count = 12): [number, number][] {
  const now = new Date();
  const periods: [number, number][] = [];

  for (let i = 0; i < count; i += 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    periods.push([d.getFullYear(), d.getMonth() + 1]);
  }

  return periods;
}

export function useWhalersClubRewardHistory(programId: string) {
  const now = new Date();
  const [selectedMonth, setSelectedMonth] = useState(now.getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(now.getFullYear());

  const { data, isLoading } = useQuery({
    queryKey: GamificationQueryKeys.REWARD_HISTORY(programId, selectedMonth, selectedYear),
    queryFn: () =>
      getLoyaltyRewardHistory(programId, {
        limit: 20,
        offset: 0,
        month: selectedMonth,
        year: selectedYear,
      }),
    staleTime: STALE_TIME.DEFAULT,
    cacheTime: CACHE_TIME.DEFAULT,
    enabled: !!programId,
  });

  const availablePeriods = useMemo(() => generateAvailablePeriods(), []);

  const handleMonthChange = useCallback((value: string) => {
    const [year, month] = value.split('-').map(Number);
    setSelectedYear(year);
    setSelectedMonth(month);
  }, []);

  return {
    rewardHistoryRecords: data?.data ?? [],
    availablePeriods,
    activePeriod: `${selectedYear}-${selectedMonth}`,
    handleMonthChange,
    isLoading,
  };
}
